import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Fade,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { getUrl } from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTryUpdate,
} from "common/method/handleNotificationAlert";
import { useEffect, useState } from "react";
import { MdOutlineRefresh } from "react-icons/md";
import { useDispatch } from "react-redux";
import { actionTypes } from "redux/offlineorder/select_offline_orders";
import { actionTypes as actionTypesNotif } from "redux/notificationAlert";
import { confirm_offline_order_otp } from "redux/offlineorder/confirm_offline_order_otp";
import { verify_offline_order_otp } from "redux/offlineorder/verify_offline_order_otp";

const OtpModalOfflineOrder = ({
  isOtpModalOpen,
  setOtpModalOpen,
  selectedItems,
}) => {
  const [otp, setOtp] = useState("");
  const [shouldFetchData, setShouldFetchData] = useState(true);
  const [apiResponse, setApiResponse] = useState(null);
  const [captchaCode, setCaptchaCode] = useState("");
  const [loading, setLoading] = useState(false);

  const [isShowOtp, setIsShowOtp] = useState(false);

  const fetchData = async () => {
    try {
      const response = await apiCall();
      setApiResponse(response.data?.response?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  let dispatch = useDispatch();

  const apiCall = () => {
    let config = {
      baseURL: getUrl(),
      method: "POST",
      headers: {
        "content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: "login",
      data: {
        api_key: "d025488f-8ec6-4434-afbe-b6a5343815a7",
        token: null,
        member_id: null,
        table: "clubmember",
        method_type: "get_captcha",
        data: {},
      },
    };

    return axios(config);
  };
  const handleOtpSubmit = () => {
    if (!selectedItems || !captchaCode) return;

    let data = {
      _id: selectedItems,
      captcha_id: apiResponse?._id,
      captcha_value: captchaCode,
    };
    setLoading(true);
    confirm_offline_order_otp(data)
      .then((res) => {
        if (res?.data?.response?.is_successful === true) {
          dispatch({
            type: actionTypesNotif.success,
            textAlert: "پیامکی حاوی کد تایید برای شما ارسال خواهد شد",
          });
          setIsShowOtp(true);
        } else {
          handleNotificationAlertTryUpdate(res);
        }
      })
      .catch(() => {
        handleNotificationAlertCatch();
        setShouldFetchData(true);
      })
      .finally(() => {
        setLoading(false);
        setShouldFetchData(true);
      });
  };
  const verifyOtp = () => {
    if (!selectedItems || !otp) return;
    let data = {
      _id: selectedItems,
      otp: +otp,
    };

    setLoading(true);
    verify_offline_order_otp(data)
      .then((res) => {
        handleNotificationAlertTryUpdate(res);
        dispatch({
          type: actionTypes.selectOfflineOrdersAsync,
          payload: { data: { state: -1 } },
        });
      })
      .catch(() => {
        handleNotificationAlertCatch();
      })
      .finally(() => {
        setLoading(false);
        setOtpModalOpen(false);
        setIsShowOtp(false);
      });
  };
  useEffect(() => {
    if (shouldFetchData && isOtpModalOpen) {
      fetchData();
      setShouldFetchData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchData, isOtpModalOpen]);
  const base64Image = apiResponse?.img;
  const imgSrc = base64Image?.startsWith("data:image")
    ? base64Image
    : `data:image/jpeg;base64,${base64Image}`;
  const handleRefreshClick = () => {
    setShouldFetchData(true);
  };

  return (
    <div>
      {" "}
      <Modal
        open={isOtpModalOpen}
        onClose={() => {
          setOtpModalOpen(false);
          setIsShowOtp(false);
          setCaptchaCode("");
          setOtp("");
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={isOtpModalOpen}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              maxWidth: 400,
              width: "100%",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              تایید ارسال سفارشات
            </Typography>
            {isShowOtp && (
              <TextField
                sx={{ marginBlock: 4 }}
                fullWidth
                label="کد تایید ارسال شده"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            )}
            {!isShowOtp && (
              <div style={{ flex: 1, marginBlockStart: 4 }}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 8,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    placeholder="کد امنیتی"
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={captchaCode}
                    onCha
                    name="captcha"
                    onChange={(e) => {
                      setCaptchaCode(e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <>
                          {apiResponse?.img ? (
                            <img
                              style={{ maxHeight: 36 }}
                              height={16}
                              alt=""
                              src={imgSrc}
                            />
                          ) : (
                            <div
                              style={{
                                minWidth: 70,
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                              }}
                            >
                              <CircularProgress size={16} />
                            </div>
                          )}
                          <MdOutlineRefresh
                            onClick={handleRefreshClick}
                            style={{ cursor: "pointer" }}
                            size={44}
                          />
                        </>
                      ),
                    }}
                    inputProps={{
                      style: {
                        textAlign: "right",
                        direction: "rtl",
                      },
                    }}
                  />
                </div>
              </div>
            )}
            <Box sx={{ marginTop: 2, textAlign: "center" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={isShowOtp ? verifyOtp : handleOtpSubmit}
                disabled={loading}
              >
                {isShowOtp ? "ثبت سفارشات" : "ارسال کد تایید "}
                {loading && <CircularProgress size={18} />}
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default OtpModalOfflineOrder;
